module.exports = __webpack_public_path__ + "static/media/pie-chart.8aa175f9.svg";